import { FULLNAME_REGEX, NAME_REGEX } from '@modules/validation/util/regex';

/** Matches MGE `StringHelpers::validName` length check (per first/last field). */
const HDE_MGE_NAME_MAX_LENGTH = 50;

const CHARSET_MESSAGE =
    'Letters, hyphens, apostrophes, dots, commas, and spaces only.';

interface HdeFullNameValidationOptions {
    /** Guest name copy on the guest invitation step */
    guest?: boolean;
}

/**
 * Validates a single "full name" field: exactly first + last (no middle name), FULLNAME shape,
 * then each part must satisfy NAME_REGEX and be at most {@link HDE_MGE_NAME_MAX_LENGTH} characters.
 */
export function getHdeFullNameValidationError(
    value: string,
    options?: HdeFullNameValidationOptions,
): string | null {
    const t = value.trim();
    if (!t) {
        return null;
    }
    const parts = t.split(/\s+/).filter(Boolean);
    if (parts.length < 2) {
        return options?.guest
            ? 'Enter your guest’s first and last name.'
            : 'Enter your first and last name.';
    }
    if (parts.length > 2) {
        return options?.guest
            ? 'Enter only your guest’s first and last name (no middle name).'
            : 'Enter only your first and last name (no middle name).';
    }
    const split = { first: parts[0]!, last: parts[1]! };
    if (!FULLNAME_REGEX.test(t)) {
        return CHARSET_MESSAGE;
    }
    if (
        split.first.length > HDE_MGE_NAME_MAX_LENGTH ||
        split.last.length > HDE_MGE_NAME_MAX_LENGTH
    ) {
        return `Each part of your name must be ${HDE_MGE_NAME_MAX_LENGTH} characters or fewer.`;
    }
    if (!NAME_REGEX.test(split.first) || !NAME_REGEX.test(split.last)) {
        return CHARSET_MESSAGE;
    }

    return null;
}

export function isHdeFullNameValid(value: string): boolean {
    const t = value.trim();
    if (!t) {
        return false;
    }

    return getHdeFullNameValidationError(t) === null;
}
